import {
	EditorImageIcon,
	EditorSubtitlesIcon,
	EditorTitleIcon,
	FormatBoldIcon,
	FormatItalicIcon,
	FormatQuoteIcon,
} from "@/components/ui/wysiwyg-editor/components/icon";

import { EditorMenuItemButton } from "./components/button/menu-item-button";
import { useEditorMenu } from "./hooks/use-menu";

import type { Editor } from "@tiptap/react";

type Props = {
	editor: Editor;
	uploadImage: (file: File) => Promise<string>;
};

export const TiptapFloatingMenu = ({ editor, uploadImage }: Props) => {
	const {
		isSelectedTitle,
		handleTitle,
		isSelectedBold,
		handleBold,
		isSelectedItalic,
		handleItalic,
		isSelectedQuote,
		handleQuote,
		isSelectedSubtitles,
		handleSubtitles,
		handleImage,
	} = useEditorMenu({ editor, uploadImage });

	return (
		<div className="bottom-10 left-10 flex items-center rounded border border-zinc-200 bg-white shadow">
			<EditorMenuItemButton handleClick={handleTitle} isSelecting={isSelectedTitle}>
				<EditorTitleIcon />
			</EditorMenuItemButton>
			<EditorMenuItemButton handleClick={handleBold} isSelecting={isSelectedBold}>
				<FormatBoldIcon />
			</EditorMenuItemButton>
			<EditorMenuItemButton handleClick={handleItalic} isSelecting={isSelectedItalic}>
				<FormatItalicIcon />
			</EditorMenuItemButton>
			<EditorMenuItemButton handleClick={handleQuote} isSelecting={isSelectedQuote}>
				<FormatQuoteIcon />
			</EditorMenuItemButton>
			<EditorMenuItemButton handleClick={handleSubtitles} isSelecting={isSelectedSubtitles}>
				<EditorSubtitlesIcon />
			</EditorMenuItemButton>

			<EditorMenuItemButton isSelecting={false} className="relative">
				<input
					type="file"
					accept="image/png, image/jpeg, image/jpg, image/gif"
					className="absolute left-0 top-0 h-full w-full opacity-0 hover:cursor-pointer"
					onChange={handleImage}
				/>
				<EditorImageIcon />
			</EditorMenuItemButton>
		</div>
	);
};

TiptapFloatingMenu.displayName = "TiptapFloatingMenu";
